import Actions from "./userPreferenceConstants";
import produce from "immer";

const initialState = {
  loading: false,
  data: null,
  operationResult: null,
};

export const reducer = (state = initialState, action) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case Actions.GET_USER_PREFERENCES:
        draft.loading = true;
        draft.data = null;
        draft.operationResult = null;
        return;
      case Actions.GET_USER_PREFERENCES_SUCCEEDED:
        draft.loading = false;
        draft.data = action.payload.Data;
        draft.operationResult = null;
        return;
      case Actions.GET_USER_PREFERENCES_FAILED:
        draft.loading = false;
        draft.data = null;
        draft.operationResult = action.payload?.Operation ?? {
          Outcome: "Error",
          Message: "Could not load user preferences.",
        };
        return;
      case Actions.UPDATE_USER_PREFERENCES:
        draft.loading = true;
        draft.operationResult = null;
        return;
      case Actions.UPDATE_USER_PREFERENCES_SUCCEEDED:
        draft.loading = false;
        draft.data = {
          ...(draft.data || {}),
          ...action.payload.Data,
        };
        draft.operationResult = action.payload.Operation;
        return;
      case Actions.UPDATE_USER_PREFERENCES_FAILED:
        draft.loading = false;
        draft.operationResult = action.payload?.Operation ?? {
          Outcome: "Error",
          Message: "Could not update user preferences.",
        };
        return;
      case Actions.CLEAR_USER_PREFERENCES_OPERATION_RESULT:
        draft.operationResult = null;
        return;
      default:
        return;
    }
  });
};
